import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import { Store } from '../../types';

interface StoresSyncState {
    syncingStores: Store[];
}

const initialState: StoresSyncState = {
    syncingStores: [],
};

const isSyncing = (store: Store): boolean =>
    store.syncState === 1 || store.syncV2IsRunning === 1;

const storesSyncSlice = createSlice({
    name: 'storesSync',
    initialState,
    reducers: {
        setSyncingStores: (state, action: PayloadAction<Store[]>) => {
            state.syncingStores = action.payload.filter(isSyncing);
        },
        addSyncingStore: (state, action: PayloadAction<Store>) => {
            const alreadySyncing = state.syncingStores.some(store => store.id === action.payload.id);
            if (!alreadySyncing) {
                state.syncingStores.push({ ...action.payload, syncState: 1 });
            }
        },
    },
});

export const { setSyncingStores, addSyncingStore } = storesSyncSlice.actions;

export const selectSyncingStores = (state: RootState): Store[] => state.storesSync.syncingStores;

export const buildStoreSyncingSelector = (storeId: number) => (state: RootState): boolean =>
    state.storesSync.syncingStores.some(store => store.id === storeId);

export default storesSyncSlice.reducer;
